<section class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-2xl tw-mx-auto">

    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Mis Alertas</h1>
      <p class="tw-text-slate-500 tw-text-sm tw-mt-1">Gestiona tus notificaciones de vacantes compatibles con tu CV.</p>
    </div>

    <!-- ── Uso del mes ─────────────────────────────────────────────────────── -->
    <div class="tw-relative tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-5"
         style="box-shadow:0 1px 3px rgba(0,0,0,.08)">
      <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
        <h2 class="tw-text-base tw-font-semibold tw-text-slate-800">Uso de alertas este mes</h2>
        <span class="tw-text-sm tw-font-medium" [style.color]="status.isPremium ? '#059669' : '#64748b'">
          {{ status.isPremium ? 'Premium ∞' : status.alertasUsadas + '/' + status.alertasLimite }}
        </span>
      </div>
      <div *ngIf="!status.isPremium" class="tw-w-full tw-h-2 tw-bg-slate-100 tw-rounded-full tw-mb-4">
        <div class="tw-h-2 tw-rounded-full"
             [style.width]="pct + '%'"
             [style.background]="pct >= 100 ? '#ef4444' : pct >= 80 ? '#f59e0b' : '#22c55e'"
             style="transition:width .5s ease"></div>
      </div>
      <p *ngIf="!status.isPremium" class="tw-text-xs tw-text-slate-400">
        Plan Free: <strong>{{ status.alertasLimite - status.alertasUsadas }}</strong> alerta(s) restante(s) este mes · enviadas por email.
      </p>
      <p *ngIf="status.isPremium" class="tw-text-xs" style="color:#059669">
        Alertas Premium activas · email y WhatsApp · frecuencia: <strong>{{ currentFreqLabel }}</strong>.
      </p>
      <!-- Paywall overlay -->
      <div *ngIf="status.paywallActivo"
           class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-rounded-2xl"
           style="backdrop-filter:blur(12px);background:rgba(255,255,255,.6)">
        <div class="tw-text-center tw-p-8 tw-max-w-xs tw-rounded-2xl tw-border tw-border-white/60"
             style="background:rgba(255,255,255,.85);box-shadow:0 8px 32px rgba(0,0,0,.12)">
          <div class="tw-mx-auto tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-text-white tw-text-2xl tw-mb-4"
               style="background:linear-gradient(135deg,#3b82f6,#06b6d4)">⚡</div>
          <h3 class="tw-text-lg tw-font-semibold tw-text-slate-900">Límite alcanzado</h3>
          <p class="tw-mt-2 tw-text-sm tw-text-slate-500 tw-mb-5">
            Usaste tus {{ status.alertasLimite }} alertas gratuitas este mes.<br>
            Activa Premium para alertas diarias por email y WhatsApp.
          </p>
          <button (click)="goPremium()"
                  class="tw-w-full tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-transition tw-border-0 tw-cursor-pointer"
                  style="background:#1d4ed8">
            Ver plan Premium
          </button>
        </div>
      </div>
    </div>

    <!-- ── Alertas por Email (GRATIS) ──────────────────────────────────────── -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-5"
         style="box-shadow:0 1px 3px rgba(0,0,0,.08)">
      <div class="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div class="tw-w-9 tw-h-9 tw-rounded-lg tw-flex tw-items-center tw-justify-center"
             style="background:#dbeafe">
          <svg class="tw-w-5 tw-h-5" style="color:#2563eb" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
        </div>
        <div class="tw-flex-1">
          <h2 class="tw-text-base tw-font-semibold tw-text-slate-800">Alertas por Email</h2>
          <p class="tw-text-xs tw-text-slate-400">
            {{ status.isPremium ? 'Ilimitadas — incluido en Premium' : 'Gratis — hasta 2 alertas / mes' }}
          </p>
        </div>
        <span *ngIf="status.correoSet"
              class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold"
              style="background:#dbeafe;color:#1d4ed8">
          ✓ Activo
        </span>
        <span *ngIf="!status.correoSet"
              class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold"
              style="background:#fef9c3;color:#854d0e">
          Sin email
        </span>
      </div>

      <div *ngIf="status.correoSet"
           class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl"
           style="background:#f0f9ff;border:1px solid #bae6fd">
        <svg class="tw-w-4 tw-h-4 tw-flex-shrink-0" style="color:#0284c7" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <span class="tw-text-sm tw-text-slate-700">
          Enviando a <strong>{{ status.correoPreview }}</strong>
        </span>
      </div>

      <div *ngIf="!status.correoSet" class="tw-text-center tw-py-4">
        <p class="tw-text-sm tw-text-slate-500 tw-mb-3">Agrega tu email para recibir alertas gratis.</p>
        <a routerLink="/editar-perfil"
           class="tw-inline-block tw-px-6 tw-py-2 tw-rounded-xl tw-text-white tw-font-medium tw-text-sm"
           style="background:#2563eb">
          Activar Gratis — Agregar email
        </a>
      </div>
    </div>

    <!-- ── Frecuencia de alertas (PREMIUM) ─────────────────────────────────── -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-5"
         style="box-shadow:0 1px 3px rgba(0,0,0,.08)">
      <div class="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div class="tw-w-9 tw-h-9 tw-rounded-lg tw-flex tw-items-center tw-justify-center"
             style="background:#fef3c7">
          <svg class="tw-w-5 tw-h-5" style="color:#d97706" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div class="tw-flex-1">
          <h2 class="tw-text-base tw-font-semibold tw-text-slate-800">Frecuencia de envío</h2>
          <p class="tw-text-xs tw-text-slate-400">Con qué frecuencia recibes notificaciones · sólo Premium</p>
        </div>
        <span *ngIf="status.isPremium"
              class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold"
              style="background:#fef3c7;color:#92400e">
          {{ currentFreqLabel }}
        </span>
      </div>

      <!-- No premium -->
      <div *ngIf="!status.isPremium" class="tw-text-center tw-py-4">
        <p class="tw-text-sm tw-text-slate-500 tw-mb-4">
          Plan Free envía alertas diariamente cuando hay compatibilidad ≥70%.<br>
          Con Premium puedes elegir la frecuencia que prefieras.
        </p>
        <button (click)="goPremium()"
                class="tw-px-6 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                style="background:linear-gradient(135deg,#3b82f6,#06b6d4)">
          ⚡ Personalizar con Premium
        </button>
      </div>

      <!-- Premium: opciones de frecuencia -->
      <div *ngIf="status.isPremium" class="tw-space-y-2">
        <button *ngFor="let f of frequencies"
                (click)="setFrequency(f.value)"
                [disabled]="savingFreq"
                class="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-text-left tw-cursor-pointer tw-transition"
                [style.border-color]="status.alertFrequency === f.value ? '#3b82f6' : '#e2e8f0'"
                [style.background]="status.alertFrequency === f.value ? '#eff6ff' : '#ffffff'">
          <div>
            <p class="tw-text-sm tw-font-semibold"
               [style.color]="status.alertFrequency === f.value ? '#1d4ed8' : '#334155'">
              {{ f.label }}
            </p>
            <p class="tw-text-xs tw-text-slate-400">{{ f.desc }}</p>
          </div>
          <svg *ngIf="status.alertFrequency === f.value" class="tw-w-5 tw-h-5 tw-flex-shrink-0" style="color:#2563eb" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
          </svg>
        </button>
        <p *ngIf="freqMsg" class="tw-text-xs tw-mt-2"
           [style.color]="freqMsg.includes('Error') ? '#dc2626' : '#059669'">{{ freqMsg }}</p>
      </div>
    </div>

    <!-- ── Alertas por WhatsApp ──────────────────────────────────── -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-5"
         style="box-shadow:0 1px 3px rgba(0,0,0,.08)">
      <div class="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div class="tw-w-9 tw-h-9 tw-rounded-lg tw-flex tw-items-center tw-justify-center"
             style="background:#dcfce7">
          <svg class="tw-w-5 tw-h-5" style="color:#16a34a" fill="currentColor" viewBox="0 0 448 512">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
          </svg>
        </div>
        <div class="tw-flex-1">
          <h2 class="tw-text-base tw-font-semibold tw-text-slate-800">Alertas por WhatsApp</h2>
          <p class="tw-text-xs tw-text-slate-400">
            {{ (status.isPremium || status.freeAlertWhatsapp) ? 'Recibe notificaciones directas en tu celular' : (status.whatsappPhoneSet ? 'Verificado — las alertas por WhatsApp son un beneficio Premium' : 'Disponible con plan Premium') }}
          </p>
        </div>
        <span *ngIf="status.whatsappOptIn"
              class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold"
              style="background:#dcfce7;color:#15803d">
          ✓ Activo
        </span>
      </div>

      <!-- FREE sin WhatsApp habilitado → CTA premium -->
      <ng-container *ngIf="!status.isPremium && !status.freeAlertWhatsapp && !status.whatsappPhoneSet">

        <div *ngIf="!showWaForm" class="tw-text-center tw-py-4">
          <p class="tw-text-sm tw-text-slate-500 tw-mb-4">
            Recibe alertas instantáneas cuando haya una vacante con +70% de compatibilidad con tu CV.
          </p>
          <button (click)="showWaForm = true"
                  class="tw-px-6 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                  style="background:linear-gradient(135deg,#3b82f6,#06b6d4)">
            ⚡ Activar con Premium
          </button>
        </div>

        <div *ngIf="showWaForm" class="tw-space-y-4">
          <div class="tw-px-4 tw-py-3 tw-rounded-xl" style="background:#eff6ff;border:1px solid #bfdbfe">
            <p class="tw-text-sm tw-font-medium tw-text-blue-800 tw-mb-0">
              Registra tu WhatsApp y te redirigimos al pago 🚀
            </p>
          </div>

          <!-- Phone input (siempre visible) -->
          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-2">Número WhatsApp</label>
            <div class="tw-flex tw-items-center tw-gap-2">
              <select [(ngModel)]="selectedDialCode"
                      [disabled]="otpSent"
                      class="tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-bg-slate-50 tw-font-medium tw-text-slate-600 tw-flex-shrink-0 tw-outline-none tw-cursor-pointer"
                      style="padding-left:10px;padding-right:8px;box-sizing:border-box">
                <option *ngFor="let c of countries" [value]="c.dial">{{ c.flag }} +{{ c.display }}</option>
              </select>
              <input type="tel" [(ngModel)]="phoneNumber"
                     [disabled]="otpSent"
                     placeholder="55 1234 5678"
                     class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none"
                     style="box-sizing:border-box">
            </div>
          </div>

          <!-- OTP input (visible después de enviar código) -->
          <div *ngIf="otpSent" class="tw-space-y-3">
            <div>
              <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-2">Código de verificación (6 dígitos)</label>
              <input type="text" [(ngModel)]="otpCode"
                     maxlength="6" inputmode="numeric" autocomplete="one-time-code"
                     placeholder="000000"
                     class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-text-center tw-tracking-widest tw-font-mono tw-outline-none"
                     style="box-sizing:border-box;font-size:18px;letter-spacing:8px">
            </div>
            <p class="tw-text-xs tw-text-slate-400">Código enviado a {{ fullPhone }}. Válido por 5 minutos.</p>
          </div>

          <p *ngIf="otpMsg" class="tw-text-sm"
             [style.color]="otpMsg.includes('Error') || otpMsg.includes('incorrecto') || otpMsg.includes('expirado') ? '#dc2626' : '#059669'">
            {{ otpMsg }}
          </p>

          <div class="tw-flex tw-gap-3" *ngIf="!otpSent">
            <button (click)="showWaForm = false; msg = ''; otpMsg = ''"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-slate-600 tw-font-medium tw-text-sm tw-border tw-border-slate-200 tw-bg-white tw-cursor-pointer">
              Cancelar
            </button>
            <button (click)="savePhoneAndPay()"
                    [disabled]="sendingOtp || !phoneNumber.trim()"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                    style="background:#1d4ed8"
                    [style.opacity]="!phoneNumber.trim() ? '0.5' : '1'">
              {{ sendingOtp ? 'Enviando código...' : 'Enviar código →' }}
            </button>
          </div>

          <div class="tw-flex tw-gap-3" *ngIf="otpSent">
            <button (click)="otpSent = false; otpCode = ''; otpMsg = ''"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-slate-600 tw-font-medium tw-text-sm tw-border tw-border-slate-200 tw-bg-white tw-cursor-pointer">
              ← Cambiar número
            </button>
            <button (click)="verifyOtpCode(true)"
                    [disabled]="verifyingOtp || otpCode.trim().length !== 6"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                    style="background:#1d4ed8"
                    [style.opacity]="otpCode.trim().length !== 6 ? '0.5' : '1'">
              {{ verifyingOtp ? 'Verificando...' : 'Verificar y pagar →' }}
            </button>
          </div>
        </div>
      </ng-container>

      <!-- PREMIUM o FREE con WhatsApp habilitado por admin → configurar o mostrar activo -->
      <ng-container *ngIf="status.isPremium || status.freeAlertWhatsapp || status.whatsappPhoneSet">

        <div *ngIf="status.whatsappOptIn && !showWaForm"
             class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl"
             style="background:#f0fdf4;border:1px solid #bbf7d0">
          <svg class="tw-w-4 tw-h-4" style="color:#15803d" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
          </svg>
          <span class="tw-text-sm tw-text-green-700">
            WhatsApp configurado y activo.
          </span>
          <button (click)="showWaForm = true; phoneNumber = ''"
                  class="tw-ml-auto tw-text-xs tw-text-blue-600 tw-underline tw-bg-transparent tw-border-0 tw-cursor-pointer">
            Cambiar número
          </button>
        </div>

        <div *ngIf="!status.whatsappOptIn && !showWaForm" class="tw-text-center tw-py-4">
          <button (click)="showWaForm = true"
                  class="tw-px-6 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                  style="background:#16a34a">
            Configurar WhatsApp
          </button>
        </div>

        <div *ngIf="showWaForm" class="tw-space-y-4">
          <!-- Phone input -->
          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-2">Número WhatsApp</label>
            <div class="tw-flex tw-items-center tw-gap-2">
              <select [(ngModel)]="selectedDialCode"
                      [disabled]="otpSent"
                      class="tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-bg-slate-50 tw-font-medium tw-text-slate-600 tw-flex-shrink-0 tw-outline-none tw-cursor-pointer"
                      style="padding-left:10px;padding-right:8px;box-sizing:border-box">
                <option *ngFor="let c of countries" [value]="c.dial">{{ c.flag }} +{{ c.display }}</option>
              </select>
              <input type="tel" [(ngModel)]="phoneNumber"
                     [disabled]="otpSent"
                     placeholder="55 1234 5678"
                     class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none"
                     style="box-sizing:border-box">
            </div>
          </div>

          <!-- OTP input -->
          <div *ngIf="otpSent" class="tw-space-y-3">
            <div>
              <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-2">Código de verificación (6 dígitos)</label>
              <input type="text" [(ngModel)]="otpCode"
                     maxlength="6" inputmode="numeric" autocomplete="one-time-code"
                     placeholder="000000"
                     class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-text-center tw-tracking-widest tw-font-mono tw-outline-none"
                     style="box-sizing:border-box;font-size:18px;letter-spacing:8px">
            </div>
            <p class="tw-text-xs tw-text-slate-400">Código enviado a {{ fullPhone }}. Válido por 5 minutos.</p>
          </div>

          <p *ngIf="otpMsg" class="tw-text-sm"
             [style.color]="otpMsg.includes('Error') || otpMsg.includes('incorrecto') || otpMsg.includes('expirado') ? '#dc2626' : '#059669'">
            {{ otpMsg }}
          </p>

          <div class="tw-flex tw-gap-3" *ngIf="!otpSent">
            <button (click)="showWaForm = false; msg = ''; otpMsg = ''"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-slate-600 tw-font-medium tw-text-sm tw-border tw-border-slate-200 tw-bg-white tw-cursor-pointer">
              Cancelar
            </button>
            <button (click)="saveWhatsapp()"
                    [disabled]="sendingOtp || !phoneNumber.trim()"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                    style="background:#16a34a"
                    [style.opacity]="!phoneNumber.trim() ? '0.5' : '1'">
              {{ sendingOtp ? 'Enviando código...' : 'Enviar código OTP →' }}
            </button>
          </div>

          <div class="tw-flex tw-gap-3" *ngIf="otpSent">
            <button (click)="otpSent = false; otpCode = ''; otpMsg = ''"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-slate-600 tw-font-medium tw-text-sm tw-border tw-border-slate-200 tw-bg-white tw-cursor-pointer">
              ← Cambiar número
            </button>
            <button (click)="verifyOtpCode(false)"
                    [disabled]="verifyingOtp || otpCode.trim().length !== 6"
                    class="tw-flex-1 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                    style="background:#16a34a"
                    [style.opacity]="otpCode.trim().length !== 6 ? '0.5' : '1'">
              {{ verifyingOtp ? 'Verificando...' : 'Verificar código OTP' }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ── Cómo funciona ────────────────────────────────────────────────────── -->
    <div class="tw-rounded-2xl tw-p-5 tw-border" style="background:#eff6ff;border-color:#bfdbfe">
      <h3 class="tw-text-sm tw-font-semibold tw-mb-3" style="color:#1e3a8a">¿Cómo funcionan las alertas?</h3>
      <ul class="tw-space-y-2 tw-text-xs" style="color:#1d4ed8">
        <li class="tw-flex tw-gap-2"><span>1.</span> La IA analiza tu CV activo con cada ejecución.</li>
        <li class="tw-flex tw-gap-2"><span>2.</span> Cuando encuentra una vacante con ≥70% de compatibilidad, te notifica.</li>
        <li class="tw-flex tw-gap-2"><span>3.</span> <strong>Gratis:</strong> hasta 2 alertas/mes por email · 1 vez al día.</li>
        <li class="tw-flex tw-gap-2"><span>4.</span> <strong>Premium:</strong> alertas diarias por email y WhatsApp · elige la frecuencia.</li>
      </ul>
    </div>

  </div>
</section>
